import React, { useState } from "react";
import CardsCripto from "../../assets/images/card-moviement.png";
import Tilt from "react-parallax-tilt";

export default function TiltImage() {
  return (
    <div className="">
      <Tilt
        tiltMaxAngleX={15}
        tiltMaxAngleY={15}
        perspective={1000}
        scale={1.05}
        transitionSpeed={250}
        glareEnable={true}
        glareMaxOpacity={0.2}
      >
        <img
          src={CardsCripto}
          alt="Imagem dos cartões"
          className="w-[700px] h-auto rounded-xl"
        />
      </Tilt>
    </div>
  );
}
